import { submit } from 'ducks/workflow';
import SubmitButton from 'components/buttons/workflow/SubmitButton';
import workflow from './workflow';

export default workflow({ action: submit })(SubmitButton);
